{
    "Accessibility menu": "Menu dostępności",
    "Close": "Zamknij",
    "Content adjustments": "Dostosowania Treści",
    "Navigation adjustments": "Dostosowania Nawigacji",
    "Text Align": "Text Align",
    "Align Left": "Wyrównaj do Lewej",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Dostosuj Rozmiar Czcionki",
    "Highlight Title": "Podświetl Tytuł",
    "Highlight Links": "Podświetl Linki",
    "Readable Font": "Czytelna Czcionka",
    "Colour adjustments": "Dostosowania Kolorów",
    "Dark Contrast": "Ciemny Kontrast",
    "Light Contrast": "Jasny Kontrast",
    "High Contrast": "Wysoki Kontrast",
    "High Saturation": "Wysokie Nasycenie",
    "Low Saturation": "Niskie Nasycenie",
    "Monochrome": "Monochromatyczny",
    "Tools": "Narzędzia",
    "Reading Guide": "Przewodnik Czytania",
    "Big Cursor": "Duży Kursor",
    "Increase Font Size": "Zwiększ Rozmiar Czcionki",
    "Decrease Font Size": "Zmniejsz Rozmiar Czcionki",
    "Letter Spacing": "Odstęp Liter",
    "Line Height": "Wysokość Linii",
    "Font Weight": "Grubość Czcionki",
    "Dyslexia Font": "Czcionka dla Dysleksji",
    "Language": "Język",
    "Accessibility widget": "Otwórz menu dostępności",
    "Accessibility Profiles": "Profile Dostępności",
    "Cognitive Disability": "Niepełnosprawność Poznawcza",
    "Seizure Safe": "Bezpieczny dla Padaczki",
    "Accessibility statement": "Oświadczenie o Dostępności",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Zatrzymaj Animacje",
    "Reset all settings": "Resetuj ustawienia",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
